import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loading", "onChange", "open", "options"],
  _excluded2 = ["children", "option"];
let _ = t => t,
  _t;
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Typeahead } from 'foundations-components/transitional/components/Typeahead';
import styledWithTheme from 'foundations-theming/utils';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledWrapper = styledWithTheme.div(_t || (_t = _`
  flex-basis: 100%;

  ul[role="listbox"] {
    max-height: unset;
  }
`));

/**
 * Copied from foundations-components/transitional/components/Typeahead/TypeaheadResultsItem.types
 */

export default function MobileTypeaheadResults(_ref) {
  let {
      loading,
      onChange,
      open = true,
      options
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ItemComponent = useCallback(_ref2 => {
    let {
        children,
        option
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    if (loading) {
      return /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true
      });
    }
    if (!option) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
      onClick: () => onChange(option),
      children: /*#__PURE__*/_jsx(View, {
        paddingBlock: "100",
        children: option.dropdownText || children
      })
    }));
  }, [loading, onChange]);
  if (!open) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexGrow: 1,
    alignItems: "stretch",
    children: /*#__PURE__*/_jsx(StyledWrapper, {
      children: /*#__PURE__*/_jsx(Typeahead, Object.assign({}, props, {
        enableKeyboardScrollingNav: true,
        itemComponent: ItemComponent,
        minimumSearchCount: Infinity,
        options: loading ? [] : options
      }))
    })
  });
}